/**
 * Non-blocking asset loading progress bar.
 * Renders a thin 2px bar at the top of map-area + a small text chip.
 * Returns null when idle (zero DOM footprint).
 */

import './AssetLoadingBar.css';

interface AssetLoadingBarProps {
  total: number;
  loaded: number;
  isActive: boolean;
  isDone: boolean;
}

export default function AssetLoadingBar({ total, loaded, isActive, isDone }: AssetLoadingBarProps) {
  if (!isActive && !isDone) return null;

  const pct = total > 0 ? Math.round((loaded / total) * 100) : 0;

  return (
    <div className={`asset-loading-bar${isDone ? ' asset-loading-bar--fading' : ''}`}>
      <div className="asset-loading-bar__track">
        <div
          className={`asset-loading-bar__fill${isDone ? ' asset-loading-bar__fill--done' : ''}`}
          style={{ width: `${isDone ? 100 : pct}%` }}
        />
      </div>
    </div>
  );
}
